import * as React from "react";
import { GroupCreateForm } from "./form";

export const GroupCreateInitializer: React.FC = () => {
  return <GroupCreateForm />;
};
